import { render, staticRenderFns } from "./ListadosProformaGeneral.vue?vue&type=template&id=7ebcbb48&lang=html"
import script from "./ListadosProformaGeneral.vue?vue&type=script&lang=js"
export * from "./ListadosProformaGeneral.vue?vue&type=script&lang=js"
import style0 from "./ListadosProformaGeneral.vue?vue&type=style&index=0&id=7ebcbb48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports